import type { InsulinTotalInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileUnit } from "./TileUnit"
import { TileValue } from "./TileValue"
import { usePolyglot } from "src/contexts"
import { limitInsulinDigits } from "src/utils/limitInsulinDigits"

export function InsulinTotal(props: TileProps<InsulinTotalInsight>) {
  const {
    insightKey,
    range,
  } = props

  const polyglot = usePolyglot()

  const { insulinCalculations } = useCalculationsContext()
  const { totalInsulinUnits } = insulinCalculations[range] || {}
  const value = limitInsulinDigits(totalInsulinUnits)

  const unit = polyglot.t(
    "unit.units",
    isNaN(value) ? 0 : value,
  )

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue id={`${insightKey}-value`}>
        {isNaN(value) ? "--" : value.toLocaleString(polyglot.locale())}
      </TileValue>
      <TileUnit id={`${insightKey}-unit`}>
        {unit}
      </TileUnit>
    </>
  )
}
